import { cn } from '@/lib/utils';

type Props = {
  height?: string;
  className?: string;
};

function VerticalDivider({ height = '', className }: Props) {
  return (
    <span
      className={cn('inline-block w-px bg-border', !height && 'h-3', className)}
      style={height ? { height } : undefined}
      aria-hidden
    />
  );
}

export default VerticalDivider;
